import { render, staticRenderFns } from "./ContinueChat.vue?vue&type=template&id=4eb7c297"
import script from "./ContinueChat.vue?vue&type=script&lang=js"
export * from "./ContinueChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports